import appLogger from "@next-platform/client-common-core/logger/appLogger";
import { ButtonSize, ButtonVariant, Modal } from "@next-platform/client-common-spicy-ui";
import { JSX } from "react";

const logger = appLogger.withTag("SubmitForReviewModal");

interface SubmitForReviewModalProps {
  title: string;
  onUserConfirmation: () => Promise<void | { error: string }>;
  isLoading: boolean;
  handleClose: () => void;
  confirmationMessage: string;
  isVisible: boolean;
  actionButtonText: string;
  discardButtonText: string;
}

function SubmitForReviewModal({
  title,
  onUserConfirmation,
  isLoading = false,
  handleClose,
  confirmationMessage,
  isVisible,
  actionButtonText,
  discardButtonText,
}: SubmitForReviewModalProps): JSX.Element {
  const onUserConfirmationClickHandler = async () => {
    try {
      await onUserConfirmation();
    } catch (error) {
      logger.error("Error in onUserConfirmationClickHandler", error);
    }
  };

  const onClose = () => {
    handleClose?.();
  };

  return (
    <Modal
      title={title}
      description={confirmationMessage}
      dismissable={!isLoading}
      aria-labelledby="confirmation modal"
      open={isVisible}
      onOpenChange={onClose}
      closeOnActions={false}
      actions={[
        { label: discardButtonText, size: ButtonSize.LARGE, variant: ButtonVariant.OUTLINED, onPress: onClose },
        { label: actionButtonText, size: ButtonSize.LARGE, onPress: onUserConfirmationClickHandler, loading: isLoading },
      ]}
    />
  );
}

export default SubmitForReviewModal;
